import { COMPANY, LAWYER } from '../../../shared/constants/ProfileProductId';
import { ProfileProductHelper } from '../../../shared/helper/ProfileProductHelper';
import { LawyerResponse, UserResponse, CompanyResponse } from '../../../shared/types/User';
import { COUNTER_TYPES, MAP_APP_COUNTER_TYPE } from '../../../shared/types/statistic/CounterType';

export interface SendParams {
  counterType: COUNTER_TYPES;
  entityId: number;
}

enum entityNameType {
  LAWYER = 'User',
  COMPANY = 'Company',
}

export class Statistic {
  private readonly urlScheme = import.meta.env.VITE_STATISTIC_URL;
  private readonly debug: boolean;
  private readonly enableOnLoadCounter: boolean;
  private readonly entityName: 'Company' | 'User';
  private response: UserResponse;
  private appName: string;

  constructor(response: UserResponse, appName: string, debug?: boolean) {
    this.debug = debug || import.meta.env.DEV;
    this.enableOnLoadCounter = !import.meta.env.DEV;
    this.response = response;
    this.appName = appName;
    this.entityName = entityNameType[this.setProductId(response)];
  }

  private setProductId(response: UserResponse) {
    const { getProfileProductId } = ProfileProductHelper(response);
    return getProfileProductId().toUpperCase() as Uppercase<typeof COMPANY | typeof LAWYER>;
  }

  sendOnPageLoad() {
    if (this.enableOnLoadCounter) {
      const entityId =
        this.entityName === entityNameType['COMPANY']
          ? (this.response as CompanyResponse).company.companyId
          : (this.response as LawyerResponse).lawyer.userId;
      this.sendCounter({
        counterType: MAP_APP_COUNTER_TYPE[this.appName],
        entityId,
      });
    }
  }

  public sendCounter(params: SendParams) {
    const url = `${this.urlScheme}${String(params.counterType)}/${this.entityName}/${String(params.entityId)}`;
    if (this.debug) console.log('Counter: send was called', url);
    fetch(url).catch((error) => console.warn(error));
  }
}
